import { OnboardingEvent } from '@weave/schema-gen-ts/dist/shared/insys/activation/onboarding.pb';
import { SchemaIO, SchemaOnboardingProgressService } from '@frontend/schema';

export { TaskStatus } from '@weave/schema-gen-ts/dist/schemas/insys/onboarding/v1/onboarding-tasks/onboarding_tasks.pb';

export enum GuideType {
  GuidedWalkthrough,
  ExternalLink,
}

export enum ModuleName {
  Standalone = 'standalone',
  Payments = 'payments',
  Reviews = 'reviews',
}

export enum TaskType {
  Location = 'location',
  User = 'user',
}

export enum TaskCompletionType {
  Modules = 'Modules',
  Ordinary = 'Ordinary',
}

export enum TaskIds {
  EINSetup = 1,
  PaymentsStripeSetup = 2,
  ReviewsSetup = 3,
  UserInviteSetup = 4,
  PortalWelcomeExperience = 5,
  ScheduleCallWithOnboarder = 16,
  Schedule1on1Training = 17,
  PhonesShipped = 18,
  PortingInformation = 19,
  Register10DLC = 20,
  MessagingAutoReminder = 23,
  MessagingFirstText = 24,
  PortDate = 25,
  E911 = 27,
}

export enum ModuleIds {
  Standalone = 1,
  Payments = 2,
  Reviews = 3,
  OnlineScheduling = 4,
  TextConnect = 5,
}

export type TaskTrayStepInfo = {
  id: string;
  title: string;
  description?: string;
  information?: string;
  imageUrl?: string;
};

export type TaskTrayTaskInfo = {
  id: number;
  title: string;
  description?: string;
  information?: string;
  imageUrl?: string;
  isCompleted: boolean;
  moduleId: number;
  isOptional?: boolean;
};

export type TaskTrayModuleInfo = {
  id: number;
  title: string;
  description?: string;
  information?: string;
  isCompleted: boolean;
  tasks: TaskTrayTaskInfo[];
  progressText: string;
  progressValue: number;
};

export type TaskTrayModuleListInfo = {
  modules: TaskTrayModuleInfo[];
  progressText: string;
  progressValue: number;
};

export type ResendUserInviteRequest = SchemaIO<typeof SchemaOnboardingProgressService.ResendUserInviteEmail>['input'];
export type ResendUserInviteResponse = SchemaIO<typeof SchemaOnboardingProgressService.ResendUserInviteEmail>['output'];

export type IsUserSetupCompleteRequest = SchemaIO<typeof SchemaOnboardingProgressService.IsUserSetupComplete>['input'];
export type IsUserSetupCompleteResponse = SchemaIO<
  typeof SchemaOnboardingProgressService.IsUserSetupComplete
>['output'];

export interface PublishOnboardingEventRequest {
  slug: string;
  locationId: string;
  onboardingEvent: OnboardingEvent;
}
